import React, {} from 'react';
const styles = {"wordmark":"Wordmark-module__wordmark__xXyyg","accent":"Wordmark-module__accent__IaPcf"};
/** "Trip" plus "OS" in the accent colour (boards B1, C1). It is named by `label`, not by the visible letters. */
export function Wordmark({ label, href, size = 'md' }) {
    const letters = (React.createElement("span", { "aria-hidden": "true" },
        "Trip",
        React.createElement("span", { className: styles.accent }, "OS")));
    let wordmark;
    if (href === undefined) {
        wordmark = (React.createElement("span", { className: styles.wordmark, role: "img", "aria-label": label, "data-size": size }, letters));
    }
    else {
        wordmark = (React.createElement("a", { className: styles.wordmark, href: href, "aria-label": label, "data-size": size }, letters));
    }
    return wordmark;
}
//# sourceMappingURL=Wordmark.js.map